export interface Result {
    [key: string]: string;
}